module.exports = __webpack_public_path__ + "img/logo-with-name-below.3951b9f9.svg";